module.exports = __webpack_public_path__ + "img/code2.5d21715f.jpeg";